.lab {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
}

.title {
  font-size: var(--tuna-fontsize-xl);
  font-weight: 700;
  margin: 0;
}

.workspace {
  display: flex;
  gap: var(--tuna-spacing-4);
  flex-wrap: wrap;
}

.left {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  flex: 1 1 auto;
  min-width: 0;
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-3);
}

.resetButton {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-3);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
  cursor: pointer;
}

@media (max-width: 959px) {
  .workspace {
    flex-direction: column;
  }
}
